import { setInitialState } from "../../../../utils/reducerOperations";
export function Default() {
    return {
        getTopicListApi: setInitialState(),
        getTextQuestionListApi: setInitialState(),
        getThemesListApi: setInitialState(),
        reprocessTopicsApi: setInitialState()
    };
}
